import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hover-over"
export default class extends Controller {
  connect() {
  }
}
